// Select all elements with the class 'swatch_button Size-button'
const buttons = document.querySelectorAll(
    "input.swatch_button.Size-button, input.swatch_button.color-swatch"
);
var inventoryThreshold = parseInt(
    window.PXUTheme.theme_settings.inventory_threshold
);
const product_count_one = window.PXUTheme.translation.product_count_other;
const product = JSON.parse(
    document.querySelector(".product_form").dataset["product"]
);
const productParentSelector = ".product-" + product.id + " .js-product_section";

function initializeProductImages() {
    const isDesktop = window.innerWidth > 768;
    const selectedOptions = Array.from(
        document.querySelectorAll(".swatch input:checked")
    ).map((input) => input.value);
    const gallery = document.querySelector(".product-gallery");

    if (gallery && isDesktop) {
        if (selectedOptions.length > 0) {
            const option1 = selectedOptions[0];
            const allImages = gallery.querySelectorAll("img");

            allImages.forEach((img) => {
                img.style.display = "none";
            });

            const matchingImages = gallery.querySelectorAll(
                `img[alt="${option1}"], img[alt="All"]`
            );
            matchingImages.forEach((img) => {
                img.style.display = "block";
            });
        }
    } else if (gallery && !isDesktop) {
        const allImages = gallery.querySelectorAll("img");
        allImages.forEach((img) => {
            img.style.display = "block";
        });
    }
}

function attachEventListeners() {
    document.querySelectorAll(".swatch input").forEach((input) => {
        input.addEventListener("change", initializeProductImages);
    });

    window.addEventListener("resize", initializeProductImages);
}

function initializeColorSwatches() {
    const availableOptions = product.variants
        .filter(v => v.available)
        .map(v => v.option1);
    const uniqueOptions = [...new Set(availableOptions)];

    $(productParentSelector + ' .swatch[data-option-index="0"] .swatch-element').each(function () {
        if (uniqueOptions.includes($(this).attr("data-value"))) {
            $(this)
                .removeClass("soldout")
                .find(":radio")
                .prop("disabled", false);
        } else {
            $(this)
                .addClass("soldout")
                .find(":radio")
                .prop("disabled", true);
        }
    });

    const selectedColor = $(productParentSelector + ' .swatch[data-option-index="0"] input:checked').val();

    const availableSizes = product.variants
        .filter(v => v.available && v.option1 === selectedColor)
        .map(v => v.option2);

    $(productParentSelector + ' .swatch[data-option-index="1"] .swatch-element').each(function () {
        const sizeValue = $(this).attr("data-value");

        if (availableSizes.includes(sizeValue)) {
            $(this)
                .removeClass("soldout")
                .find(":radio")
                .prop("disabled", false);

            if (!$(productParentSelector + ' .swatch[data-option-index="1"] input:checked').length) {
                $(this).find(":radio").prop("checked", true);
            }
        } else {
            $(this)
                .addClass("soldout")
                .find(":radio")
                .prop("checked", false)
                .prop("disabled", true);
        }
    });

    $(productParentSelector + ' .swatch[data-option-index="1"] .swatch-element').off('click').on('click', function (e) {
        if ($(this).hasClass('soldout')) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    });

    $(productParentSelector + ' .swatch[data-option-index="1"] .swatch-element.soldout input[type="radio"]').off('click').on('click', function (e) {
        e.preventDefault();
        return false;
    });

    applyHideSizeForColor(selectedColor);
}

function applyHideSizeForColor(selectedColor) {
    if (!selectedColor) return;

    var hadCheckedHiddenSize = false;

    $(productParentSelector + ' .swatch[data-option-index="1"] .swatch-element').each(function () {
        var hideColorsRaw = $(this).attr("data-hide-size-colors") || "";
        var hideColors = hideColorsRaw
            .split(",")
            .map(function (c) { return c.trim(); })
            .filter(Boolean);
        var shouldHide = hideColors.indexOf(selectedColor) !== -1;
        var $radio = $(this).prev(':radio');

        if (shouldHide) {
            $(this).addClass("hide-size");
            $radio.prop("disabled", true);

            if ($radio.prop("checked")) {
                $radio.prop("checked", false);
                hadCheckedHiddenSize = true;
            }
        } else {
            $(this).removeClass("hide-size");

            if (!$(this).hasClass("soldout")) {
                $radio.prop("disabled", false);
            }
        }
    });

    if (hadCheckedHiddenSize) {
        var $fallback = $(productParentSelector + ' .swatch[data-option-index="1"] .swatch-element')
            .not(".hide-size")
            .not(".soldout")
            .first();

        if ($fallback.length) {
            var fallbackRadio = $fallback.prev(':radio')[0];

            if (fallbackRadio) {
                fallbackRadio.checked = true;
                fallbackRadio.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }
    }
}

function updateSwatchAvailability() {
    var form = document.querySelector(".product_form form");
    if (!form) return;

    var groups = Array.from(
        form.querySelectorAll(".swatch[data-option-index]")
    ).sort(function (a, b) {
        return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex);
    });

    var selected = groups.map(function (group) {
        var checked = group.querySelector("input:checked");
        return checked ? checked.value : "";
    });

    groups.forEach(function (group, index) {
        group.querySelectorAll(".swatch-element").forEach(function (el) {
            var value = el.getAttribute("data-value");
            var radio = el.querySelector("input[type='radio']") || el.previousElementSibling;

            var isAvailable = product.variants.some(function (v) {
                if (!v.available || v.options[index] !== value) return false;

                for (var i = 0; i < index; i++) {
                    if (v.options[i] !== selected[i]) return false;
                }

                return true;
            });

            el.classList.toggle("soldout", !isAvailable);

            if (radio) {
                radio.disabled = !isAvailable || el.classList.contains("hide-size");

                if (!isAvailable && radio.checked) {
                    radio.checked = false;
                }
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", () => {
    const initializeAll = () => {
        handleUrlVariant();
        initializeProductImages();
        attachEventListeners();
        selectFirstAvailableSize();
        initializeProductText();
        initializeColorSwatches();
        setTimeout(updateSwatchAvailability, 200);
    };

    function handleUrlVariant() {
        const url = new URL(window.location.href);
        const variantId = url.searchParams.get("variant");

        if (variantId) {
            const variant = product.variants.find(v => v.id.toString() === variantId);

            if (variant) {
                selectVariant(variant, true);
            } else {
                selectDefaultVariant();
            }
        } else {
            selectDefaultVariant();
        }
    }

    function selectDefaultVariant() {
        const firstAvailableVariant = product.variants.find(v => v.available);

        if (firstAvailableVariant) {
            const url = new URL(window.location.href);
            url.searchParams.set("variant", firstAvailableVariant.id);
            window.history.replaceState({}, "", url);

            selectVariant(firstAvailableVariant);
        }
    }

    function selectVariant(variant, fromUrl = false) {
        // Use the product form directly instead of the global `parent` name.
        const form = document.querySelector(".product_form form");
        if (!form || !variant) return;

        const colorInput = Array.from(
            form.querySelectorAll('.swatch[data-option-index="0"] input')
        ).find((input) => input.value === variant.option1);

        if (colorInput) {
            colorInput.checked = true;
            colorInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        setTimeout(() => {
            if (variant.option2) {
                const sizeInput = Array.from(
                    form.querySelectorAll('.swatch[data-option-index="1"] input')
                ).find((input) => input.value === variant.option2);

                if (sizeInput) {
                    sizeInput.checked = true;
                    sizeInput.dispatchEvent(new Event("change", { bubbles: true }));
                } else if (!fromUrl) {
                    selectFirstAvailableSize();
                }
            }

            if (variant.option3) {
                const option3Input = Array.from(
                    form.querySelectorAll('.swatch[data-option-index="2"] input')
                ).find((input) => input.value === variant.option3);

                if (option3Input) {
                    option3Input.checked = true;
                    option3Input.dispatchEvent(new Event("change", { bubbles: true }));
                }
            }
        }, 100);
    }
        function selectFirstAvailableSize() {
        const selectedColor = document.querySelector(
            `${productParentSelector} .swatch[data-option-index="0"] input:checked`
        )?.value;

        if (selectedColor) {
            const availableSizes = product.variants
                .filter(v => v.available && v.option1 === selectedColor)
                .map(v => v.option2);

            if (availableSizes.length > 0) {
                document.querySelectorAll(`${productParentSelector} .swatch[data-option-index="1"] input`).forEach(input => {
                    input.checked = false;
                });

                const firstAvailableSize = Array.from(
                    document.querySelectorAll(`${productParentSelector} .swatch[data-option-index="1"] input`)
                ).find(input => input.value === availableSizes[0]);

                if (firstAvailableSize) {
                    firstAvailableSize.checked = true;
                    firstAvailableSize.dispatchEvent(new Event("change", { bubbles: true }));

                    const newVariant = product.variants.find(
                        v => v.available && v.option1 === selectedColor && v.option2 === availableSizes[0]
                    );

                    if (newVariant) {
                        const url = new URL(window.location.href);
                        url.searchParams.set("variant", newVariant.id);
                        window.history.replaceState({}, "", url);
                    }
                }
            }
        }
    }

    function initializeProductText() {
        const selectedVariant = product.variants.find(
            (item) => item.id.toString() === selectedVariantId
        );

        if (selectedVariant) {
            const colortextElement = document.getElementById("colortext");

            if (colortextElement && selectedVariant.option1) {
                colortextElement.innerHTML = selectedVariant.option1;
            }

            const sizeElement = document.getElementById("sizetext");
            const waistElement = document.getElementById("waisttext");

            if (sizeElement && selectedVariant.option2) {
                sizeElement.innerHTML = selectedVariant.option2;
            } else if (waistElement && selectedVariant.option2) {
                waistElement.innerHTML = selectedVariant.option2;
            }

            const inseamElement = document.getElementById("inseamtext");

            if (inseamElement && selectedVariant.option3) {
                inseamElement.innerHTML = selectedVariant.option3;
            }
        }
    }

    // Select the first available size.
    function selectFirstAvailableSize() {
        const selectedColor = $(productParentSelector + ' .swatch[data-option-index="0"] input:checked').val();

        if (selectedColor) {
            const sizeElements = $(productParentSelector + ' .swatch[data-option-index="1"] .swatch-element');
            let firstAvailableFound = false;

            sizeElements.find(':radio').prop('checked', false);

            sizeElements.each(function () {
                if (!firstAvailableFound && !$(this).hasClass('soldout')) {
                    $(this).find(':radio')
                        .prop('checked', true)
                        .trigger('change');

                    firstAvailableFound = true;
                }
            });

            if (!firstAvailableFound && sizeElements.length > 0) {
                sizeElements.first().find(':radio')
                    .prop('checked', true)
                    .trigger('change');
            }
        }
    }

    setTimeout(initializeAll, 100);

    window.addEventListener('load', () => {
        setTimeout(initializeAll, 500);
    });
});


// Pre-order update
const $product = $(".product-" + product.id);
const shipDate =
    document.querySelector(".product_form form").parentElement.dataset.shipDate;

// Inventory update
const qty = JSON.parse(
    document.querySelector(".product_form").dataset["variantInventory"]
);

const url = new URL(window.location.href);
const variantValue = url.searchParams.get("variant");
const selectedVariantId =
    document.querySelector(".product_form").dataset["selectedVariant"];

const selectedVariant = product.variants.find(
    (item) => item.id == selectedVariantId
);

var onLoadSoldOut =
    product.variants.filter(
        (variant) => !variant.available && variant.id == variantValue
    ).length > 0
        ? true
        : false;

optionsMap = {};

for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];

    if (variant.available) {
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = Shopify.uniq(optionsMap["root"]);

        if (product.options.length > 1) {
            var key2 = variant.option1;
            optionsMap[key2] = optionsMap[key2] || [];
            optionsMap[key2].push(variant.option2);
            optionsMap[key2] = Shopify.uniq(optionsMap[key2]);
        }

        if (product.options.length === 3) {
            var key2 = variant.option1 + " / " + variant.option2;
            optionsMap[key2] = optionsMap[key2] || [];
            optionsMap[key2].push(variant.option3);
            optionsMap[key2] = Shopify.uniq(optionsMap[key2]);
        }
    }
}

var key3 = null;
var key4 = null;
const parentElement = document.querySelector(".select-container");

const observer2 = new MutationObserver(function (mutationsList, observer) {
    key3 = $(productParentSelector + " .single-option-selector:eq(0)").val();
    key4 = $(productParentSelector + " .single-option-selector:eq(1)").val();

    function updateSwatchElements(key, optionIndex) {
        if (key || optionIndex === 0) {
            var availableOptions;

            if (optionIndex === 0) {
                availableOptions = optionsMap["root"] || product.variants
                    .filter(v => v.available)
                    .map(v => v.option1)
                    .filter((v, i, a) => a.indexOf(v) === i);
            } else {
                availableOptions = optionsMap[optionIndex == 1 ? key3 : key3 + " / " + key4];
            }

            if (availableOptions) {
                var sizeChecked = false;
                let firstAvailableOption = null;

                $(productParentSelector + ' .swatch[data-option-index="' + optionIndex + '"] .swatch-element').each(function () {
                    const isAvailable = $.inArray($(this).attr("data-value"), availableOptions) !== -1;

                    if (isAvailable) {
                        $(this)
                            .removeClass("soldout")
                            .find(":radio")
                            .removeAttr("disabled", "disabled");

                        if (!firstAvailableOption) {
                            firstAvailableOption = this;
                        }
                    } else {
                        $(this)
                            .addClass("soldout")
                            .find(":radio")
                            .removeAttr("checked")
                            .attr("disabled", "disabled");

                        this.previousElementSibling.checked = false;
                    }
                });

                $(productParentSelector + ' .swatch[data-option-index="' + optionIndex + '"] .swatch-element').each(function () {
                    const isAvailable = $.inArray($(this).attr("data-value"), availableOptions) !== -1;

                    if (isAvailable) {
                        if (selectedVariant && selectedVariant.options[optionIndex] === this.dataset.value) {
                            this.previousElementSibling.checked = true;
                            sizeChecked = true;
                        }
                    }
                });

                if (!sizeChecked && firstAvailableOption) {
                    firstAvailableOption.previousElementSibling.checked = true;
                    sizeChecked = true;

                    if (!onLoadSoldOut) {
                        var urlTemp = new URL(window.location.href);

                        urlTemp.searchParams.set(
                            "variant",
                            optionIndex === 0
                                ? firstAvailableOption.previousElementSibling.dataset["availableVariant"]
                                : selectedVariantId
                        );

                        window.history.replaceState({}, "", urlTemp);
                    }
                }
            }
        }
    }

    updateSwatchElements(null, 0);

    setTimeout(() => {
        updateSwatchElements(key3, 1);
        updateSwatchElements(key4, 2);
    }, 50);

    if (key3 || key4) {
        if (onLoadSoldOut) {
            var message = window.PXUTheme.translation.soldOut;

            $(".was-price", $product).text("");
            $(".savings", $product).text("");
            $(".preorder-date__wrapper").text(" ");
            $(".current_price", $product).text("");
            $(".items_left", $product).text("");
            $("[data-max-inventory-management]", $product).removeAttr("max");
            $(".sold_out", $product).text(message);

            $("[data-add-to-cart-trigger]", $product)
                .addClass("disabled")
                .attr("disabled", "disabled")
                .find("span:not(.icon)")
                .text(message);

            $(".shopify-payment-button", $product).hide();
            $(".purchase-details__quantity", $product).hide();

            onLoadSoldOut = false;
        }

        initializeProductImages();
        observer2.disconnect();
    }
});

observer2.observe(parentElement, { childList: true, subtree: true });

function handleButtonChange(event) {
    if (!event || !event.target || !event.target.checked) {
        return;
    }

    const input = event.target;
    const form = input.closest(".product_form form");

    if (!form) {
        return;
    }

    const groups = Array.from(
        form.querySelectorAll(".swatch[data-option-index]")
    ).sort(function (a, b) {
        return (
            Number(a.dataset.optionIndex) -
            Number(b.dataset.optionIndex)
        );
    });

    const optionCount = product.options.length;

    let selectedOptions = groups.map(function (group) {
        const checked = group.querySelector("input:checked");
        return checked ? checked.value : "";
    });

    // OPTION 1 / COLOR CHANGED
    if (Number(input.closest(".swatch").dataset.optionIndex) === 0) {
        const color = selectedOptions[0];

        if (!color) {
            return;
        }

        const colorVariants = product.variants.filter(function (variant) {
            return variant.available && variant.option1 === color;
        });

        if (!colorVariants.length) {
            return;
        }

        let matchingVariant = colorVariants.find(function (variant) {
            return (
                variant.option2 === selectedOptions[1] &&
                (
                    optionCount < 3 ||
                    variant.option3 === selectedOptions[2]
                )
            );
        });

        if (!matchingVariant && optionCount >= 2) {
            matchingVariant = colorVariants.find(function (variant) {
                return variant.option2 === selectedOptions[1];
            });
        }

        if (!matchingVariant) {
            matchingVariant = colorVariants[0];
        }

        if (optionCount >= 2 && matchingVariant.option2) {
            const neckInput = Array.from(
                groups[1].querySelectorAll("input")
            ).find(function (radio) {
                return radio.value === matchingVariant.option2;
            });

            if (neckInput) {
                neckInput.checked = true;
            }
        }

        if (optionCount >= 3 && matchingVariant.option3) {
            const sleeveInput = Array.from(
                groups[2].querySelectorAll("input")
            ).find(function (radio) {
                return radio.value === matchingVariant.option3;
            });

            if (sleeveInput) {
                sleeveInput.checked = true;
            }
        }

        selectedOptions = groups.map(function (group) {
            const checked = group.querySelector("input:checked");
            return checked ? checked.value : "";
        });
    }

    // OPTION 2 / NECK SIZE CHANGED
    if (Number(input.closest(".swatch").dataset.optionIndex) === 1) {
        const color = selectedOptions[0];
        const neck = selectedOptions[1];

        if (!color || !neck) {
            return;
        }

        const neckVariants = product.variants.filter(function (variant) {
            return (
                variant.available &&
                variant.option1 === color &&
                variant.option2 === neck
            );
        });

        if (!neckVariants.length) {
            return;
        }

        let matchingVariant = neckVariants.find(function (variant) {
            return (
                optionCount < 3 ||
                variant.option3 === selectedOptions[2]
            );
        });

        if (!matchingVariant) {
            matchingVariant = neckVariants[0];
        }

        if (optionCount >= 3 && matchingVariant.option3) {
            const sleeveInput = Array.from(
                groups[2].querySelectorAll("input")
            ).find(function (radio) {
                return radio.value === matchingVariant.option3;
            });

            if (sleeveInput) {
                sleeveInput.checked = true;
            }
        }

        selectedOptions = groups.map(function (group) {
            const checked = group.querySelector("input:checked");
            return checked ? checked.value : "";
        });
    }

    // OPTION 3 / SLEEVE CHANGED
    if (Number(input.closest(".swatch").dataset.optionIndex) === 2) {
        selectedOptions = groups.map(function (group) {
            const checked = group.querySelector("input:checked");
            return checked ? checked.value : "";
        });
    }

    // Find the exact available variant.
    const variant = product.variants.find(function (candidate) {
        if (!candidate.available) {
            return false;
        }

        return candidate.options
            .slice(0, optionCount)
            .every(function (value, index) {
                return value === selectedOptions[index];
            });
    });

    if (!variant) {
        console.warn("No available variant found:", selectedOptions);

        $("[data-add-to-cart-trigger]", $product)
            .addClass("disabled")
            .attr("disabled", "disabled");

        return;
    }

    // Make sure swatches exactly match the variant.
    variant.options
        .slice(0, optionCount)
        .forEach(function (value, index) {
            if (!groups[index]) {
                return;
            }

            const radio = Array.from(
                groups[index].querySelectorAll("input")
            ).find(function (input) {
                return input.value === value;
            });

            if (radio) {
                radio.checked = true;
            }
        });

    updateSwatchAvailability();

    // Update Color text.
    const colorText = document.getElementById("colortext");

    if (colorText) {
        colorText.innerHTML = variant.option1 || "";
    }

    // Update Neck / Waist text.
    const sizeText = document.getElementById("sizetext");
    const waistText = document.getElementById("waisttext");

    if (variant.option2) {
        if (sizeText) {
            sizeText.innerHTML = variant.option2;
        }

        if (waistText) {
            waistText.innerHTML = variant.option2;
        }
    }

    // Update Sleeve / Inseam text.
    const inseamText = document.getElementById("inseamtext");

    if (inseamText && variant.option3) {
        inseamText.innerHTML = variant.option3;
    }

    // Update gallery.
    const gallery = document.querySelector(".product-gallery");

    if (gallery) {
        const images = gallery.querySelectorAll("img");

        if (window.innerWidth > 768) {
            images.forEach(function (img) {
                img.style.display =
                    img.alt === variant.option1 || img.alt === "All"
                        ? "block"
                        : "none";
            });
        } else {
            images.forEach(function (img) {
                img.style.display = "block";
            });
        }
    }

    // Update SKU.
    const skuElement = document.getElementsByClassName("sku")[0];

    if (skuElement) {
        skuElement.innerHTML = variant.sku || "";
    }

    // Update URL.
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", url);

    // Update price.
    const priceElement = document.getElementsByClassName("current_price")[0];

    if (priceElement) {
        if (variant.price > 0) {
            priceElement.innerHTML =
                '<span class="money">' +
                Shopify.formatMoney(
                    variant.price,
                    $("body").data("money-format")
                ) +
                "</span>";
        } else {
            priceElement.innerHTML =
                window.PXUTheme.translation.free_price_text;
        }
    }

    // Update hidden Shopify variant selector.
    const productSelect = document.getElementById(
        "product-select-" + product.id
    );

    if (productSelect) {
        productSelect.value = String(variant.id);

        Array.from(productSelect.children).forEach(function (item) {
            item.selected = item.value === String(variant.id);
        });

        productSelect.dispatchEvent(
            new Event("change", { bubbles: true })
        );
    }

    // Inventory.
    const inventoryItem = qty.find(function (item) {
        return String(item.id) === String(variant.id);
    });

    const inventoryQuantity = inventoryItem
        ? inventoryItem.inventory_quantity
        : 0;

    const quantityInput = document.querySelector(
        ".has-quantity-box .quantity-input"
    );

    if (quantityInput) {
        quantityInput.max = inventoryQuantity;
    }

    // Enable Add To Cart for available variants.
    if (variant.available) {
        $("[data-add-to-cart-trigger]", $product)
            .removeClass("disabled")
            .removeAttr("disabled")
            .find("span:not(.icon)")
            .text(
                $("[data-add-to-cart-trigger]", $product).data("label")
            );

        $(".shopify-payment-button", $product).show();
        $(".purchase-details__quantity", $product).show();
    }

    // ---------------------------------------------------------
    // PRE-ORDER / INVENTORY UPDATE
    // Adapted from product_custom_DROP_2.js
    // ---------------------------------------------------------
    const selectedInventoryVariant = qty.find(function (item) {
        return String(item.id) === String(variant.id);
    });

    const quantityInputForPreorder = document.querySelector(
        ".has-quantity-box .quantity-input"
    );

    if (
        selectedInventoryVariant &&
        selectedInventoryVariant.inventory_management &&
        Number(selectedInventoryVariant.inventory_quantity) > 0
    ) {
        // In-stock inventory messaging.
        if (window.PXUTheme.theme_settings.display_inventory_left) {
            var itemsLeftText =
                window.PXUTheme.translation.product_count_other;

            const availableInventory = Number(
                selectedInventoryVariant.inventory_quantity
            );

            if (availableInventory === 1) {
                itemsLeftText =
                    window.PXUTheme.translation.product_count_one;
            }

            if (availableInventory > 5) {
                $(".items_left", $product).html("5 " + itemsLeftText);
            } else {
                $(".items_left", $product).html(
                    availableInventory + " " + itemsLeftText
                );
            }
        }

        // Apply inventory limit when inventory policy is deny.
        if (selectedInventoryVariant.inventory_policy === "deny") {
            $("[data-max-inventory-management]", $product).attr(
                "max",
                selectedInventoryVariant.inventory_quantity
            );

            if (
                window.PXUTheme.quantityBox &&
                typeof window.PXUTheme.quantityBox.updateQuantityControls === "function"
            ) {
                window.PXUTheme.quantityBox.updateQuantityControls(
                    $(".quantity-input")
                );
            }
        } else {
            $("[data-max-inventory-management]", $product).removeAttr("max");
        }

        // Restore the normal Add to Cart label.
        $("[data-add-to-cart-trigger]", $product)
            .find("span:not(.icon)")
            .text(
                $("[data-add-to-cart-trigger]", $product).data("label")
            );

        $(".preorder-date__wrapper").text(" ");

        if (
            quantityInputForPreorder &&
            selectedInventoryVariant.inventory_policy === "deny"
        ) {
            quantityInputForPreorder.max =
                selectedInventoryVariant.inventory_quantity;
        }
    } else {
        // Pre-order variant.
        if (shipDate) {
            $("[data-add-to-cart-trigger]", $product)
                .removeClass("disabled")
                .removeAttr("disabled")
                .find("span:not(.icon)")
                .text("Pre-Order Now!");

            $(".preorder-date__wrapper").text(
                "Estimated to ship " + shipDate
            );

            if (quantityInputForPreorder) {
                quantityInputForPreorder.removeAttribute("max");
            }

            $("[data-max-inventory-management]", $product).removeAttr("max");
        } else {
            // No shipping date configured.
            $("[data-add-to-cart-trigger]", $product)
                .find("span:not(.icon)")
                .text(
                    $("[data-add-to-cart-trigger]", $product).data("label")
                );

            $(".preorder-date__wrapper").text(" ");
        }

        $(".items_left", $product).text("");
        $("[data-max-inventory-management]", $product).removeAttr("max");
    }
}
// Add event listeners to each button.
$(document).off(
    "change.variantSelector",
    ".product_form .swatch input[type='radio']"
);

$(document).on(
    "change.variantSelector",
    ".product_form .swatch input[type='radio']",
    function (event) {
        handleButtonChange(event);
    }
);

// Product "Gift Card" ID: 7466982670558
if (product.id == 7466982670558) {
    const observer = new MutationObserver((mutationsList, observer) => {
        mutationsList.forEach((mutation) => {
            if (mutation.type === "childList") {
                const productSelectElement = document.getElementById(
                    "product-select-" + product.id + "-option-0"
                );

                if (productSelectElement) {
                    productSelectElement.addEventListener("change", function (event) {
                        const currentPriceMoney = document.querySelector(
                            ".current_price .money"
                        );

                        if (currentPriceMoney) {
                            currentPriceMoney.innerHTML =
                                event.target.selectedOptions[0].innerHTML;
                        }
                    });

                    observer.disconnect();
                }
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

updateOptionsInSelector = function (selectorIndex, parent) {
    switch (selectorIndex) {
        case 0:
            var key = "root";
            var selector = $(parent + " .single-option-selector:eq(0)");
            break;

        case 1:
            var key = $(parent + " .single-option-selector:eq(0)").val();
            var selector = $(parent + " .single-option-selector:eq(1)");
            break;

        case 2:
            var key = $(parent + " .single-option-selector:eq(0)").val();
            key += " / " + $(parent + " .single-option-selector:eq(1)").val();
            var selector = $(parent + " .single-option-selector:eq(2)");
            break;
    }

    var availableOptions =
        optionsMap[key] ||
        optionsMap[
            key.split(" / ")[0] + " / " + optionsMap[key.split(" / ")[0]]
        ];

    $(
        parent +
        ' .swatch[data-option-index="' +
        selectorIndex +
        '"] .swatch-element'
    ).each(function () {
        if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
            $(this)
                .removeClass("soldout")
                .find(":radio")
                .removeAttr("disabled", "disabled")
                .removeAttr("checked");
        } else {
            $(this)
                .addClass("soldout")
                .find(":radio")
                .removeAttr("checked")
                .attr("disabled", "disabled");
        }
    });
};

// Create a MutationObserver to watch for changes in the DOM.
const observer34 = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
            const productSelectElement = document.getElementById(
                "product-select-" + product.id + "-option-0"
            );

            if (productSelectElement) {
                productSelectElement.addEventListener("change", function (event) {
                    const currentPriceMoney = document.querySelector(
                        ".current_price .money"
                    );

                    if (currentPriceMoney) {
                        currentPriceMoney.innerHTML =
                            event.target.selectedOptions[0].innerHTML;
                    }
                });

                observer34.disconnect();
            }
        }
    });
});

observer34.observe(document.body, {
    childList: true,
    subtree: true
});